import './Error.css';
import React from 'react';
import { exclamation_icon } from '../shared/iconSvgs';
import { config } from '../../config';

function Error(props) {
    return (
        <>
            <div className='error-container d-flex justify-content-center'>
                <div style={{ width: '800px' }}>
                    <div>
                        <div className="icon-box">
                            <div className={'error-container-icon'}>{exclamation_icon}</div>
                        </div>
                        <h4 className="header-text w-100">An error occured</h4>
                    </div>
                    <div className="error-container-body">
                        <ul className="list-group">
                            <li className="list-group-item" style={{ fontSize: '16px' }}>{"Unexpected error occurred. If the error persists, please contact support at ma@bowl.com."}</li>
                            <li className="list-group-item" style={{ fontSize: '16px' }}>{"Error Code: Athlete-Safety-Portal-401"}</li>
                        </ul>
                    </div>
                    <div className="error-container-footer">
                        <button className="btn w-50" onClick={() => { window.location.replace(config.oidcConfig.redirect_uri) }}>{props.buttonText? props.buttonText : "Retry"}</button>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Error;